import { useCallback, useState, useEffect, useRef } from 'react'
import { Icon, useClickOutside } from '@carrent/ui'
import { useNavigate } from 'react-router-dom'
import { useAuthStore, useEventStream } from '@carrent/core'
import { adminApi, kbApi } from '@carrent/api'

export function NotificationBell() {
  const { isAdmin } = useAuthStore()
  const navigate = useNavigate()
  const [open, setOpen] = useState(false)
  const [items, setItems] = useState([])
  // Решения по моим правкам живут отдельно от напоминаний парка:
  // напоминание про ТО — общее состояние, а «вашу правку вернули» —
  // личное, и смешивать их в одном списке значит потерять второе.
  const [kbUpdates, setKbUpdates] = useState([])
  const ref = useRef(null)

  const load = useCallback(() => {
    if (!isAdmin()) return
    adminApi.reminders()
      .then(r => {
        const data = r.data?.data || {}
        // reminders может вернуть объект с категориями или массив — нормализуем
        const list = Array.isArray(data) ? data
          : Object.values(data).flat().filter(Boolean)
        setItems(list)
      })
      .catch(() => {})

    kbApi.myUpdates()
      .then(r => setKbUpdates(r.data?.data || []))
      .catch(() => setKbUpdates([]))
  }, [isAdmin])

  useEffect(() => { load() }, [load])

  // Реалтайм вместо таймера: событие сообщает, что изменилось,
  // и колокольчик перечитывает список.
  useEventStream(load, { enabled: isAdmin() })

  useClickOutside(ref, () => setOpen(false))

  if (!isAdmin()) return null

  const count = items.length + kbUpdates.length

  // Открытие панели гасит счётчик правок: человек их увидел.
  const openPanel = () => {
    const next = !open
    setOpen(next)
    if (next && kbUpdates.length) {
      kbApi.markUpdatesSeen(kbUpdates.map(u => u.revision_id)).catch(() => {})
    }
  }

  const goToArticle = (u) => {
    setOpen(false)
    setKbUpdates([])
    // Ведём на саму статью: уведомление без адреса заставляло бы
    // автора искать свою правку в разделе глазами. Ключ пространства
    // приходит с обновлением; без него — общий раздел как запасной путь.
    navigate(u.space_key ? `/admin/kb/${u.space_key}/${u.page_id}` : '/admin/kb')
  }

  return (
    <div className="notif" ref={ref}>
      <button className="notif__btn" onClick={openPanel} aria-label="Уведомления">
        <Icon name="bell" size={18} />
        {count > 0 && <span className="notif__dot">{count > 9 ? '9+' : count}</span>}
      </button>

      {open && (
        <div className="notif__panel">
          {count === 0 && <div className="notif__empty">Ничего нового</div>}

          {kbUpdates.length > 0 && (
            <>
              <div className="notif__section">База знаний</div>
              {kbUpdates.map(u => (
                <button type="button" key={u.revision_id} className="notif__item notif__item--kb"
                  onClick={() => goToArticle(u)}>
                  <span className="notif__title">
                    {u.decision === 'approved'
                      ? `Правка опубликована: ${u.page_title}`
                      : `Правку вернули: ${u.page_title}`}
                  </span>
                  {u.comment && <span className="notif__comment">{u.comment}</span>}
                </button>
              ))}
            </>
          )}

          {items.length > 0 && kbUpdates.length > 0 && (
            <div className="notif__section">Автопарк</div>
          )}
          {items.map((it, i) => {
            const text = typeof it === 'string' ? it
              : (it.message || it.title || it.text
                 || `${it.car?.brand || ''} ${it.car?.plate || ''} — ${it.type || 'напоминание'}`.trim())
            const carId = it.car?.id || it.car_id
            return (
              <div key={i} className="notif__item"
                onClick={() => { setOpen(false); if (carId) navigate(`/admin/cars/${carId}`) }}>
                ⚠️ {text}
              </div>
            )
          })}
        </div>
      )}
    </div>
  )
}
